import { render, staticRenderFns } from "./EventLink.vue?vue&type=template&id=0aa02a3b&scoped=true&"
import script from "./EventLink.vue?vue&type=script&lang=js&"
export * from "./EventLink.vue?vue&type=script&lang=js&"
import style0 from "./EventLink.vue?vue&type=style&index=0&id=0aa02a3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa02a3b",
  null
  
)

export default component.exports